
import { Bookmark } from "lucide-react";

interface PlanHeaderProps {
  name: string;
  description?: string;
  instructorName: string;
  isPersonalPlan?: boolean;
}

export const PlanHeader = ({ name, description, instructorName, isPersonalPlan }: PlanHeaderProps) => {
  return (
    <>
      <div className="flex items-start justify-between mb-0 pb-0">
        <h3 className="text-lg font-semibold text-primary">{name}</h3>
        {isPersonalPlan && (
          <Bookmark className="h-5 w-5 text-clubbers-violet" />
        )}
      </div>
      {description && (
        <p className="text-sm text-muted-foreground mb-2">{description}</p>
      )}
      <p className="text-sm text-muted-foreground mb-4">
        Creado por: {instructorName}
      </p>
    </>
  );
};
